import React from 'react';
import ReactDOM from 'react-dom';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import './index.css';
import './css/investorApp.css';
import App from './App';


const store = configureStore({});
{/*
ReactDOM.render(<Provider store={store}>
    <App />
    </Provider>
    , document.getElementById('root'));
*/} 
/* registerServiceWorker(); */
ReactDOM.render(<Provider store={store}>
    <App />
    </Provider>
    , document.getElementById('root'));
